export default __webpack_public_path__ + "static/media/egg2.6cdfa1f1.jpg";